import {
  CustomPagination,
  CustomPaginationItem,
} from '@/fsd/shared/ui/pagination';
import { Dispatch, SetStateAction } from 'react';
import PaginateBankItemPageSize from '../PaginateBankItemPageSize/PaginateBankItemPageSize';
import styles from './PaginateBankItem.module.scss';

interface IProps {
  totalPages: number;
  page: number;
  handlePageChange: (event: React.ChangeEvent<unknown>, page: number) => void;
  pageSize: number;
  handlePageSizeChange: (pageSize: number) => void;
}

const PaginateBankItem = ({
  totalPages,
  page,
  handlePageChange,
  pageSize,
  handlePageSizeChange,
}: IProps) => {
  return (
    <div className={styles.paginationWrapper}>
      <CustomPagination
        count={totalPages}
        page={page}
        variant="outlined"
        shape="rounded"
        onChange={handlePageChange}
        renderItem={(item) => <CustomPaginationItem {...item} />}
      />
      <PaginateBankItemPageSize
        page_size={pageSize}
        handlePageSizeChange={handlePageSizeChange}
      />
    </div>
  );
};

export default PaginateBankItem;
